// extracted by mini-css-extract-plugin
export var sliderDots = "B_bN";
export var sliderDotsBlack = "B_bP";
export var sliderDotsBlue = "B_bQ";
export var sliderDotsDarkBlue = "B_bR";
export var sliderDotsDarkGreen = "B_bS";
export var sliderDotsGreen = "B_bT";
export var sliderDotsLightBlue = "B_bV";
export var sliderDotsWhite = "B_bW";